import DecomPoliciesGrid from './decom-policies-grid';

export default function DecomPoliciesPage() {
  return <DecomPoliciesGrid />;
}
